RivalIQ.module('export.views', function (views, App, Backbone, Marionette, $, _) {
    'use strict';

    views.Email = Marionette.LayoutView.extend({
        template: '#exportEmailTemplate',

        regions: {
            quotaRegion: '.x-quota-region'
        },

        behaviors: {
            FormValidator: {},
            AttributeBuilder: {},
            Quota: {
                behaviorClass: RivalIQ.export.behaviors.Quota
            }
        },

        ui: {
            saveBtn: '.x-save-btn'
        },

        events: {
            'click @ui.saveBtn': 'onSaveClick'
        },

        templateHelpers: function () {
            const me = this;

            return {
                types: me.model.getFiletypes()
            };
        },

        onSaveClick: function () {
            const me = this;

            me.ui.saveBtn.button('loading');
            me.triggerMethod('resetValidationErrors');

            // TODO hack b/c some reports currently take a long time to
            // generate. Also bootstrap requires more than a 10ms timeout to be
            // sure that the button has actually transitioned
            setTimeout(function () {
                const result = me.model.save(me.formAttrs);

                if (!result) {
                    return me.ui.saveBtn.button('reset');
                }

                result
                    .fail(function () {
                        me.ui.saveBtn.button('reset');
                        RivalIQ.execute('alert:danger', 'An error occurred submitting your request. Please try again');
                    });
            }, 100);
        }
    });
});
